export default __webpack_public_path__ + "static/media/Belt of Bestial Rage.8b8e51bc.jpg";